import { BranchStateService } from '@alpha-core/platform-ui';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { InboxService } from '../../services/inbox.service';

interface IDashboardConfig {
    display: boolean;
    collapsible: boolean;
    cards: Array<any>;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
    private inboxService = inject(InboxService);

    private _taskCategory: string = '';
    private _inboxConfig: { [key: string]: any } | null = null;
    private _dashboardConfig: BehaviorSubject<IDashboardConfig | null> = new BehaviorSubject<IDashboardConfig | null>(
        null,
    );
    private dashboardStatus: Promise<{ enabled: boolean }> | null = null;

    async setTaskCategory(category: string) {
        const data = await lastValueFrom(this.inboxService.getAdminInbox());
        this._inboxConfig = data;
        this._taskCategory = category;
        if (this._inboxConfig) {
            this._dashboardConfig.next(this._inboxConfig[this._taskCategory]?.dashboardConfig);
        }
    }

    private http = inject(HttpClient);

    /**
     * Build HttpParams with branch parameter
     * Uses BranchStateService to get branch from URL (defaults to 'main' if not present)
     */
    private buildParams(): HttpParams {
        const branch = BranchStateService.getBranchFromUrl();
        return new HttpParams().set('branch', branch);
    }

    async getDashboardStatus(projectId: string): Promise<{ enabled: boolean }> {
        if (this.dashboardStatus) {
            return this.dashboardStatus;
        }
        this.dashboardStatus = (
            lastValueFrom(
                this.http.post<{ enabled: boolean }>(
                    environment.ALPHA_UI_ADMIN_SERVICE_URL + '/dashboard-service/status',
                    {
                        projectId,
                    },
                    { params: this.buildParams() },
                ),
            ) as Promise<{ enabled: boolean }>
        ).catch((error) => {
            console.error(error);
            return { enabled: false };
        });
        return this.dashboardStatus;
    }

    get dashboardConfig() {
        return this._dashboardConfig;
    }
}
